import * as React from 'react';
import { Button } from 'src/components';
import { Warning } from 'src/components/Icons';
import API from 'src/services/api';

import { IItem, IAddProps, IAddState } from '../types';

import Form from './Form';

const emptyItem: IItem = {
  isDeleted: false,
  defaultProfiles: false,
  defaultItems: false,
  parameter: {
    name: '',
    id: NaN,
  },
  itemProfileVisibilityConditions: [],
  itemVisibilityConditions: [],
  itemTags: [],
  name: '',
  id: NaN,
  linkCreationNotification: null,
};

export default class Add extends React.Component<IAddProps, IAddState> {
  state: IAddState = {
    similarItems: null,
    values: null,
    withWarnings: false,
  };

  onSubmit = async (values: IItem, withWarnings: boolean) => {
    const similarItems = await API.ADMIN.ITEMS.checkSimilar(values);
    this.setState({
      values,
      withWarnings,
    });
    if (similarItems.length > 0) {
      this.setState({
        similarItems,
      });
      return;
    }
    return this.addItem();
  };

  addItem = async () => {
    const { values, withWarnings } = this.state;
    if (!values) {
      return;
    }
    await this.props.add(values, withWarnings);
    this.props.close(true);
  };

  resetSimilar = () => {
    this.setState({
      similarItems: null,
    });
  };

  render() {
    const { similarItems } = this.state;
    return (
      <div className="relative">
        <Form
          id="new"
          initialValues={emptyItem}
          onSubmit={this.onSubmit}
          {...this.props}
        />
        {similarItems && (
          <div className="absolute pin-t pin-b pin-l pin-r flex flex-col justify-center p-8 bg-grey-transparent text-center">
            <p className="text-xl font-bold">
              <Warning className="mr-2" />
              Similar items already exist
            </p>
            <div className="my-4">
              {similarItems.map((item) => (
                <span
                  key={item.id}
                  className="inline-block bg-white rounded p-2 m-2"
                >
                  {item.name} ({item.id})
                </span>
              ))}
            </div>
            <div>
              <p className="mb-3">Create anyway?</p>
              <Button onClick={this.addItem} className="mr-2">
                Yes
              </Button>
              <Button onClick={this.resetSimilar} primary={true}>
                No
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Items/components/New.tsx